import React from "react";

function RocketIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5819_4173)">
        <path
          d="M4.33993 15.9127C2.89329 17.1279 2.41107 20.7349 2.41107 20.7349C2.41107 20.7349 6.01803 20.2527 7.23321 18.806C7.91795 17.9959 7.9083 16.7518 7.14641 15.9995C6.77154 15.6417 6.27774 15.435 5.75978 15.419C5.24182 15.403 4.73619 15.5788 4.33993 15.9127Z"
          stroke="#424242"
          strokeWidth="1.92885"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5732 14.4675L8.67987 11.5742C9.19309 10.2427 9.83931 8.96645 10.6087 7.76471C11.7325 5.96797 13.2972 4.4886 15.1541 3.46731C17.011 2.44602 19.0983 1.91678 21.2174 1.92993C21.2174 4.55317 20.4652 9.16313 15.4309 12.5386C14.2127 13.3089 12.9203 13.9551 11.5732 14.4675Z"
          stroke="#424242"
          strokeWidth="1.92885"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.67986 11.5745H3.85773C3.85773 11.5745 4.38816 8.65233 5.78658 7.71683C7.34895 6.67525 10.6087 7.71683 10.6087 7.71683"
          stroke="#424242"
          strokeWidth="1.92885"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5731 14.4679V19.2901C11.5731 19.2901 14.4953 18.7596 15.4308 17.3612C16.4724 15.7988 15.4308 12.5391 15.4308 12.5391"
          stroke="#424242"
          strokeWidth="1.92885"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5819_4173">
          <path d="M0 0H23.1462V23.1462H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RocketIcon;
